import ForgotPassword from "../../component/forgot-password/forgot-password";

export default function ForgotPasswordPage() {
    return (
      <ForgotPassword />
    )
}